import styled from 'styled-components/macro'
import { FlexRow } from 'src/components/Reusable/Flex'

export const ModeToggleRow = styled(FlexRow)`
  width: 100%;
  justify-content: flex-start;
  gap: 12px;
  align-items: center;
  padding: 4px 0;
`
